export default __webpack_public_path__ + "static/media/bd.a62e330d.svg";